export const profileUrl = 'https://x.com/dr_nuhaalhazmi';

export const tweetUrl =
  'https://x.com/dr_nuhaalhazmi/status/2081703070363177409?s=20';

export const announcements = [
  'حصول طالباتي على جائزة أفضل ورقة بحثية في المؤتمر الدولي',
  'المركز الأول على مستوى الوطن العربي في أفضل رسالة دكتوراه',
];

export const tweets = [
  {
    id: 1,
    image: '/images/tweets/tweet-1.jpg',
    width: 1024,
    height: 672,
    alt: 'رسالة عن فوز طالبات الدكتورة نهى بجائزة أفضل ورقة بحثية في المؤتمر الدولي',
    text:
      'استمرارًا للنجاحات بفضل الله تعالى، وإضافة مشرفة إلى مسيرتي المهنية بكل فخر. يسعدني أن أشارككم حصول طالباتي اللاتي أشرفت على ورقتهن العلمية على جائزة أفضل ورقة بحثية في المؤتمر الدولي. فخورة جدا بطالباتي، ومنها إلى إنجازات ونجاحات أكبر بإذن الله.',
    url: tweetUrl,
  },
  {
    id: 2,
    image: '/images/tweets/tweet-2.jpg',
    width: 1024,
    height: 766,
    alt: 'رسالة عن حصول رسالة دكتوراه أشرفت الدكتورة نهى على تدقيقها على المركز الأول عربيًا',
    text:
      'الحمد لله.. إنجاز جديد يضاف لمسيرتي بكل فخر. حصلت إحدى الرسائل التي أشرفت على تدقيقها على المركز الأول على مستوى الوطن العربي في أفضل رسالة دكتوراه.',
    url: tweetUrl,
  },
];
